import { ExtensionState, usePhoneStore } from '@hit/react-jssip';
import { useEffect } from 'react';

import { useProvider } from '@/hooks/use-provider';
import { PROVIDERS } from '@/providers';

export const useOnExtensionReadyNotifier = () => {
  const extensionState = usePhoneStore((state) => state.extensionState);
  const [provider] = useProvider();

  useEffect(() => {
    if (
      extensionState === ExtensionState.Registered &&
      provider.id === PROVIDERS.OMNIHIT
    ) {
      provider.sendExtensionReadyNotification();
    }
  }, [provider, extensionState]);
};
